import RequestAbstract from "./RequestAbstract";

export default class DraftCollections extends RequestAbstract {
    get link() {
        return this.links.draftCollections;
    }
    async getAll() {
        return await super.getAll(this.getSortField("created_at"));
    }
}
